<lib-domains-list-view (editDomainOutput)="editDomain($event)"></lib-domains-list-view>
